import { render, staticRenderFns } from "./NormalSearchNav595.vue?vue&type=template&id=5f3631f5&scoped=true"
import script from "./NormalSearchNav595.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav595.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3631f5",
  null
  
)

export default component.exports